import type { IconNode, LucideIcon } from 'lucide-react'
import { createLucideIcon } from 'lucide-react'

// Pedestrian walkway.
export const WALKWAY_NODES: IconNode = [
  [
    'path',
    {
      key: 'walkway-0',
      d: 'M7 21L10 17M16 21L14 17L11 14L12 8M6 12L8 9L12 8L15 11L18 12M12 4C12 4.26522 12.1054 4.51957 12.2929 4.70711C12.4804 4.89464 12.7348 5 13 5C13.2652 5 13.5196 4.89464 13.7071 4.70711C13.8946 4.51957 14 4.26522 14 4C14 3.73478 13.8946 3.48043 13.7071 3.29289C13.5196 3.10536 13.2652 3 13 3C12.7348 3 12.4804 3.10536 12.2929 3.29289C12.1054 3.48043 12 3.73478 12 4Z',
    },
  ],
]

export const WalkwayIcon: LucideIcon = createLucideIcon(
  'walkway',
  WALKWAY_NODES,
)
